import { useState, useEffect, useRef } from 'react';

export function Timer({
  initialElapsed = 0,
  limit = 600,
  onLimitReached = () => {},
  extraLimit = null,
  onExtraLimitReached = () => {},
  showHours = false,
}) {
  const [seconds, setSeconds]  = useState(initialElapsed);
  const onLimitRef             = useRef(onLimitReached);
  const onExtraRef             = useRef(onExtraLimitReached);
  useEffect(() => { onLimitRef.current = onLimitReached; });
  useEffect(() => { onExtraRef.current = onExtraLimitReached; });
  const firedRef               = useRef(initialElapsed >= limit);
  const firedExtraRef          = useRef(extraLimit !== null && initialElapsed >= extraLimit);

  useEffect(() => {
    if (initialElapsed >= limit && !firedRef.current) {
      firedRef.current = true;
      setTimeout(() => onLimitRef.current?.(), 0);
    }
    if (extraLimit !== null && initialElapsed >= extraLimit && !firedExtraRef.current) {
      firedExtraRef.current = true;
      setTimeout(() => onExtraRef.current?.(), 0);
    }
    const id = setInterval(() => {
      setSeconds(prev => {
        const next = prev + 1;
        if (next >= limit && !firedRef.current) {
          firedRef.current = true;
          setTimeout(() => onLimitRef.current?.(), 0);
        }
        if (extraLimit !== null && next >= extraLimit && !firedExtraRef.current) {
          firedExtraRef.current = true;
          setTimeout(() => onExtraRef.current?.(), 0);
        }
        return next;
      });
    }, 1000);
    return () => clearInterval(id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const over = seconds >= limit;
  const hrs  = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  const display = showHours
    ? `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
    : `${mins}:${String(secs).padStart(2, '0')}`;

  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      marginBottom: 12,
      padding: '8px 16px',
      borderRadius: 8,
      border: `1.5px solid ${over ? '#dc3545' : '#ced4da'}`,
      background: over ? '#fff5f5' : '#f8f9fa',
      transition: 'border-color 0.4s, background 0.4s',
    }}>
      <span style={{ fontSize: 22, lineHeight: 1 }}>⏱</span>
      <span style={{ fontSize: 16, color: '#888', fontWeight: 500 }}>Time spent</span>
      <span style={{
        fontVariantNumeric: 'tabular-nums',
        fontWeight: 700,
        fontSize: 28,
        color: over ? '#dc3545' : '#333',
        transition: 'color 0.4s',
        letterSpacing: '0.5px',
      }}>
        {display}
      </span>
    </div>
  );
}
